import { useVentas  } from "../contexto/provider/VentasContext.js";

export function useVentasCanceladas() {
  const { ventas, loading } = useVentas(); // extrae el contexto completo
  const canceladas = ventas.filter(v => v.estado === "cancelada");
  return { ventas: canceladas, loading };
}
